export default function getWeeklyDateValue(date) {
  return date;
}
